var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmphatize(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.425 12.8089C23.2475 14.6314 23.2475 17.5861 21.425 19.4085L14.8254 26.0082C14.3698 26.4638 13.6311 26.4638 13.1755 26.0082L6.57582 19.4085C4.75337 17.5861 4.75337 14.6314 6.57582 12.8089C8.39826 10.9864 11.353 10.9864 13.1755 12.8089L13.9996 13.633L14.8254 12.8089C16.6479 10.9864 19.6026 10.9864 21.425 12.8089ZM14.0005 1.1665C16.5777 1.1665 18.6671 3.25584 18.6671 5.83317C18.6671 8.4105 16.5777 10.4998 14.0005 10.4998C11.4231 10.4998 9.33378 8.4105 9.33378 5.83317C9.33378 3.25584 11.4231 1.1665 14.0005 1.1665Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmphatize);
export default __webpack_public_path__ + "static/media/emphatize.f48357c701d7182fa520459b1e118904.svg";
export { ForwardRef as ReactComponent };